import IntranetService from "../services/intranet.service";

export default {
  initStore({ dispatch }) {
    dispatch("setFavouritesFromLocalStorage");
    dispatch("setLastVisitedMapsFromLocalStorage");
    dispatch("setSettingsFromLocalStorage");
    dispatch("setMapBookmarksFromLocalStorage");
    dispatch("setIsConnectedToIntranet");
  },
  setFavouritesFromLocalStorage({ commit }) {
    if (localStorage.getItem("favourites") == null) {
      commit("setFavourites", []);
    } else {
      commit(
        "setFavourites",
        JSON.parse(localStorage.getItem("favourites") || [])
      );
    }
  },
  setMapBookmarksFromLocalStorage({ commit }) {
    if (localStorage.getItem("nveMapBookmarks") == null) {
      commit("setMapBookmarks", []);
    } else {
      commit(
        "setMapBookmarks",
        JSON.parse(localStorage.getItem("nveMapBookmarks") || [])
      );
    }
  },
  setSettingsFromLocalStorage({ commit, state }) {
    if (localStorage.getItem("nveUserSettings") === null) {
      commit(
        "setUserSettings",
        JSON.parse(JSON.stringify(state.defaultUserSettings))
      );
    } else {
      commit("setUserSettings", {
        ...state.defaultUserSettings,
        ...JSON.parse(localStorage.getItem("nveUserSettings"))
      });
    }
  },
  resetUserSettings({ commit, state }) {
    commit(
      "setUserSettings",
      JSON.parse(JSON.stringify(state.defaultUserSettings))
    );
  },
  setGuideIsRunning({ commit }, payload) {
    commit("setGuideIsRunning", payload);
  },
  setHideWelcomeDialogFromLocalStorage({ commit }) {
    if (localStorage.getItem("hideWelcomeDialog") == null) {
      commit("setHideWelcomeDialog", false);
    } else {
      commit(
        "setHideWelcomeDialog",
        JSON.parse(localStorage.getItem("hideWelcomeDialog"))
      );
    }
  },
  setHide3dNavigationHelpDialogFromLocalStorage({ commit }) {
    if (localStorage.getItem("hide3dNavigationHelpDialog") == null) {
      commit("setHide3dNavigationHelpDialog", false);
    } else {
      commit(
        "setHide3dNavigationHelpDialog",
        JSON.parse(localStorage.getItem("hide3dNavigationHelpDialog"))
      );
    }
  },
  setLastVisitedMapsFromLocalStorage({ commit }) {
    if (localStorage.getItem("lastVisitedMaps") == null) {
      commit("setLastVisitedMaps", []);
    } else {
      commit(
        "setLastVisitedMaps",
        JSON.parse(localStorage.getItem("lastVisitedMaps") || [])
      );
    }
  },
  setMainThemeID({ commit }, mainThemeID) {
    commit("setMainThemeID", mainThemeID);
  },
  setMapHeight({ commit }, newMapHeight) {
    commit("setMapHeight", newMapHeight);
  },
  setShowCatalogue({ commit }, showCatalogue) {
    commit("setShowCatalogue", showCatalogue);
  },
  setShowPredefinedBookmarks({ commit }, showPredefinedBookmarks) {
    commit("setShowPredefinedBookmarks", showPredefinedBookmarks);
  },
  setMapLoaded({ commit }) {
    commit("setMapLoaded");
  },
  setIs3d({ commit }, is3d) {
    commit("setIs3d", is3d);
  },
  setZoom({ commit }, zoom) {
    commit("setZoom", zoom);
  },
  setHideWelcomeDialog({ commit }, hideWelcomeDialog) {
    commit("setHideWelcomeDialog", hideWelcomeDialog);
  },
  setHide3dNavigationHelpDialog({ commit }, hide3dNavigationHelpDialog) {
    commit("setHide3dNavigationHelpDialog", hide3dNavigationHelpDialog);
  },
  setShowTabs({ commit }, value) {
    commit("setShowTabs", value);
  },
  hideExplorer({ commit }) {
    commit("setExplorerVisible", false);
  },
  addBottomSheet({ commit }, bottomSheet) {
    commit("addBottomSheet", bottomSheet);
  },
  setShowImageGallery({ commit }, payload) {
    commit("setShowImageGallery", payload);
  },
  activateTool({ commit }, toolName) {
    commit("activateTool", toolName);
  },
  setLayerDefinitionExpression({ commit }, payload) {
    commit("setLayerDefinitionExpression", payload);
  },
  setSelectedMapProfile({ commit }, payload) {
    commit("setSelectedMapProfile", payload);
  },
  setSelectedExtent({ commit }, payload) {
    commit("setSelectedExtent", payload);
  },
  setShowPopupsOnClick({ commit }, payload) {
    commit("setShowPopupsOnClick", payload);
  },
  updateMapProfiles({ commit }, mapProfiles) {
    commit("updateMapProfiles", mapProfiles);
  },
  addGraphicsLayer({ commit }, graphicsLayerId) {
    commit("addGraphicsLayer", graphicsLayerId);
  },
  toggleProfileOpen({ commit }, profile) {
    commit("toggleProfileOpen", profile);
  },
  setImageGalleryItems({ commit }, items) {
    commit("setImageGalleryItems", items);
  },
  clearImageGalleryItems({ commit }) {
    commit("clearImageGalleryItems");
  },
  setMapProfileDate({ commit }, mapProfileDateInfo) {
    commit("setMapProfileDate", mapProfileDateInfo);
  },
  setTheMap({ commit }, theMap) {
    commit("setTheMap", theMap);
  },
  setShowSideMenu({ commit }, showSideMenu) {
    commit("setShowSideMenu", showSideMenu);
  },
  setShowAppDrawer({ commit }, showAppDrawer) {
    commit("setShowAppDrawer", showAppDrawer);
  },
  setActiveExclusiveToolName({ commit }, activeExclusiveToolName) {
    commit("setActiveExclusiveToolName", activeExclusiveToolName);
  },
  setShowMiniDrawer({ commit }, showMiniDrawer) {
    commit("setShowMiniDrawer", showMiniDrawer);
  },
  removeMapProfileFromState({ commit }, id) {
    commit("REMOVE_MAP_PROFILE_FROM_STATE", id);
  },
  setShowInfoMenu({ commit }, showInfoMenu) {
    if (typeof showInfoMenu === "object" && showInfoMenu !== null) {
      commit("setShowHovedforklaring", showInfoMenu.showHovedforklaring, {
        root: true
      });
      commit("setShowInfoMenu", showInfoMenu.showInfoMenu, { root: true });
    } else {
      commit("setShowHovedforklaring", false, {
        root: true
      });
      commit("setShowInfoMenu", showInfoMenu, { root: true });
    }
  },
  setUserAccount({ commit }, userAccount) {
    commit("setUserAccount", userAccount);
  },
  setUserIsLoggedIn({ commit }, userIsLoggedIn) {
    commit("setUserIsLoggedIn", userIsLoggedIn);
  },
  setUserLoginFailed({ commit }, userLoginFailed) {
    commit("setUserLoginFailed", userLoginFailed);
  },
  setExtent({ commit }, extent) {
    commit("setExtent", extent);
  },
  setCurrentMapScale({ commit }, currentMapScale) {
    commit("setCurrentMapScale", currentMapScale);
  },
  setSelectedBasemap({ commit }, basemap) {
    commit("setSelectedBasemap", basemap);
  },
  setProfileVisibility({ commit }, payload) {
    commit("setProfileVisibility", payload);
  },
  setSceneViewLoaded({ commit }) {
    commit("setSceneViewLoaded", true);
  },
  setStartupDialog({ commit }, payload) {
    commit("setStartupDialog", payload);
  },
  setCopiedGeometry({ commit }, geometry) {
    commit("setCopiedGeometry", geometry);
  },
  setLogoImagePath({ commit }, newLogoImagePath) {
    commit("setLogoImagePath", newLogoImagePath);
  },
  setProfileActualVisibleSublayers({ commit }, profileActualVisibleSublayers) {
    commit("setProfileActualVisibleSublayers", profileActualVisibleSublayers);
  },
  setMapProfileOpacity({ commit }, payload) {
    commit("setMapProfileOpacity", payload);
  },
  setPopupVisible({ commit }, payload) {
    commit("setPopupVisible", payload);
  },
  setUserSetting({ commit }, payload) {
    commit("setUserSetting", payload);
  },
  setSettingsDialogActive({ commit }, payload) {
    commit("setSettingsDialogActive", payload);
  },
  setSelectedTheme({ commit }, selectedTheme) {
    commit("setSelectedTheme", selectedTheme, { root: true });
  },
  addMapProfileToState({ commit }, profile) {
    commit("addMapProfile", profile);
  },
  addLayerInfo({ commit }, layerInfo) {
    commit("addLayerInfo", layerInfo);
  },
  setPhotoStreamIsActivated({ commit }, photoStreamIsActivated) {
    commit("setPhotoStreamIsActivated", photoStreamIsActivated);
  },
  removeLastVisitedMap({ commit }, map) {
    commit("removeLastVisitedMap", map);
  },
  setShowLayerInfoCard({ commit }, showLayerInfoCard) {
    commit("setShowLayerInfoCard", showLayerInfoCard);
  },
  removeCurrentlyOpenedProject({ commit }) {
    commit("setCurrentlyOpenedProject", null);
  },
  setCurrentOrientation({ commit }, currentMapOrientation) {
    commit("setCurrentOrientation", currentMapOrientation);
  },
  setBuildingsLayerAdded({ commit }, buildingsLayerAdded) {
    commit("setBuildingsLayerAdded", buildingsLayerAdded);
  },
  setCurrentlyOpenedProject({ commit }, project) {
    commit("setCurrentlyOpenedProject", project);
  },
  setPrintWidth({ commit }, newPrintWidth) {
    commit("setPrintWidth", newPrintWidth);
  },
  setSelectedPrintScale({ commit }, newPrintScale) {
    commit("setSelectedPrintScale", newPrintScale);
  },
  setSelectedPageFormat({ commit }, selectedPageFormat) {
    commit("setSelectedPageFormat", selectedPageFormat);
  },
  setBottomTabsHeight({ commit }, bottomTabsHeight) {
    commit("setBottomTabsHeight", bottomTabsHeight);
  },
  setPrintHeight({ commit }, newPrintHeight) {
    commit("setPrintHeight", newPrintHeight);
  },
  addFavourite({ commit, dispatch }, favourite) {
    dispatch("setSnack", "Et kartlag ble lagt til i favoritter");
    commit("addFavourite", favourite);
  },
  removeFavourite({ commit, dispatch }, favourite) {
    dispatch("setSnack", "Et kartlag ble fjernet fra favoritter");
    commit("removeFavourite", favourite);
  },
  removeFeatureTable({ commit }, featureTableIndex) {
    commit("removeFeatureTable", featureTableIndex);
  },
  clearCurrentlyOpenedProject({ commit }) {
    commit("setCurrentlyOpenedProject", null);
  },
  setSnack({ commit }, snack) {
    commit("setSnack", snack);
  },
  setLoadingSnack({ commit }, snack) {
    commit("setLoadingSnack", snack);
  },
  setExplorerVisible({ commit }, explorerVisible) {
    commit("setExplorerVisible", explorerVisible);
  },
  setLayersAreLoading({ commit }, layersAreLoading) {
    commit("setLayersAreLoading", layersAreLoading);
  },
  addLayerMetadata({ commit }, layerMetadata) {
    commit("addMetadata", layerMetadata);
  },
  enableSave({ commit }) {
    commit("setSaveIsEnabled", true);
  },
  disableSave({ commit }) {
    commit("setSaveIsEnabled", false);
  },
  addMapBookmark({ commit }, mapBookmark) {
    commit("addMapBookmark", mapBookmark);
  },
  editBookmarkTitle({ commit }, bookmarkEditInfo) {
    commit("editBookmarkTitle", bookmarkEditInfo);
  },
  removeMapBookmark({ commit }, mapBookmarkIndex) {
    commit("removeMapBookmark", mapBookmarkIndex);
  },
  deactivateTool({ commit }, toolName) {
    commit("deactivateTool", toolName);
  },
  setIsConnectedToIntranet({ commit }) {
    IntranetService.checkIfConnectedToIntranet().then(isConnectedToIntranet => {
      commit("setIsConnectedToIntranet", isConnectedToIntranet);
    });
  },
  getAndSetProfiles({ commit }) {
    import(/* webpackIgnore: true */ process.env.VUE_APP_CONFIG_FILES_URL +
      "profiles.js?version=" +
      new Date().getTime()).then(profileFile => {
      commit("setProfiles", profileFile.profiles);
    });
  },
  updateMapProfileName({ commit, state }, payload) {
    let index = state.mapProfiles.findIndex(
      profile => profile.id === payload.id
    );
    commit("updateMapProfileName", {
      index: index,
      newTitle: payload.newName
    });
  },
  updateMapProfileDescription({ commit, state }, payload) {
    let index = state.mapProfiles.findIndex(
      profile => profile.id === payload.id
    );
    commit("updateMapProfileDescription", {
      index: index,
      Temaforklaring: payload.Temaforklaring
    });
  },
  updateMapProfile({ commit, state }, newProfile) {
    let index = state.mapProfiles.findIndex(
      profile => profile.id === newProfile.id
    );
    commit("updateMapProfile", {
      index: index,
      newProfile: newProfile
    });
  },
  addLastVisitedMap({ commit, state }, project) {
    let mapExists = state.lastVisitedMaps.find(lastVisitedMap => {
      return lastVisitedMap.id.toLowerCase() === project.id.toLowerCase();
    });
    if (typeof mapExists === "undefined") {
      commit("addLastVisitedMap", project);
    } else {
      if (project.hash == null && mapExists.hash !== null) {
        // hvis bruker kan redigere
        project.hash = mapExists.hash;
      }
      commit("removeLastVisitedMap", mapExists);
      commit("addLastVisitedMap", project);
    }
  }
};
